import React from 'react'
import styled from 'styled-components'
import { OrganizationIndustries } from '../../../../application'
import { ToggleSwitch } from '../../../ToggleSwitch'
import { Search } from '../components/Search'
import { FilterList } from '../components/FilterList'
import { IndustriesFilterMenu } from './IndustriesFilterMenu'

interface CompaniesFilterMenuState {
  showWithVotesFilter: boolean
  withVotesFilter: boolean
  industriesFilter: OrganizationIndustries
  companyNameFilter: string
  organizationIndustriesToggle: boolean
  handleSetSearchValue: (value: string) => void
  handleToggleWithVotesFilter: () => void
  handleClearFilters: () => void
  handleIndustriesFilter: (industry: keyof OrganizationIndustries) => void
  handleOrganizationIndustriesToggle: () => void
  handleSearchKeyDown: () => void
}

export const CompaniesFilterMenu: React.FC<CompaniesFilterMenuState> = ({
  showWithVotesFilter,
  withVotesFilter,
  industriesFilter,
  companyNameFilter,
  organizationIndustriesToggle,
  handleSetSearchValue,
  handleToggleWithVotesFilter,
  handleClearFilters,
  handleIndustriesFilter,
  handleOrganizationIndustriesToggle,
  handleSearchKeyDown,
}) => {
  return (
    <>
      <Search
        value={companyNameFilter}
        setSearchValue={handleSetSearchValue}
        placeholder="Search for company"
        name="search for company"
        handleSearchKeyDown={handleSearchKeyDown}
      />
      <Separator />
      {showWithVotesFilter && (
        <ToggleSwitch active={withVotesFilter} caption="Companies with votes" onClick={handleToggleWithVotesFilter} />
      )}
      <FilterListPadding>
        <FilterList caption="Filter companies by: " clearAll={handleClearFilters} />
        <IndustriesFilterMenu
          industries={industriesFilter}
          callback={handleIndustriesFilter}
          organizationIndustriesToggle={organizationIndustriesToggle}
          handleOrganizationIndustriesToggle={handleOrganizationIndustriesToggle}
        />
      </FilterListPadding>
    </>
  )
}

const FilterListPadding = styled.div`
  padding-bottom: 2rem;
`

const Separator = styled.div`
  margin: 2rem 0;
`
